<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="24">
          <span style="color: red;">说明：补录请提交与用户添加好友时间以及用户给奶爸发ID时间（或发图片时间），必须提供以上二张截图补录可通过
          </span>
        </el-col>
        
        <el-col :span="24">
          <el-form-item label="应用" prop="app_id">
            <el-select v-model="form_data.app_id" placeholder="请选择应用">
              <el-option :label="item" :value="parseInt(index)" v-for="(item, index) in app_list"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户ID" prop="DisplayId">
            <el-input v-model="form_data.DisplayId" autocomplete="off" placeholder="请输入用户ID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="添加好友时间" prop="add_time">
            <el-date-picker v-model="form_data.add_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="截图1" prop="photo">
            <l-upload-img method="adminUserAdditional_upload" accept=".jpg,.png,.bmp" name="img" 
              :on-success="(res) => handleUploadSuccess(res, 'photo')" :preview-url="photo_preview">
            </l-upload-img>

          </el-form-item>
        </el-col>
        
        <el-col :span="24">
          <el-form-item label="截图2" prop="photo_1">
          <l-upload-img  method="adminUserAdditional_upload" accept=".jpg,.png,.bmp" name="img" 
            :on-success="(res) => handleUploadSuccess(res, 'photo_2')" :preview-url="photo_2_preview">
          </l-upload-img>
        </el-form-item>
        </el-col>
        
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
              placeholder="请输入备注" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: 'l-user-additional-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  // watch: {

  // },
  data() {
    return {
      upload_url: Vue.$_config.upload_url,
      fileList: [],
      // 修改 的图片
      photo_preview: "",
      photo_2_preview: "",
      loading: false,//页面是否加载中
      app_list:
      {
        1: "星伴"
      }
      ,
  
      //是否显示
      value1: '',
      //表单数据
      form_data: {
        DisplayId: "",
        app_id: "",
        add_time: "",
        photo: [],
        photo_1:""
      },
      //表单验证规则
      rules: {
        DisplayId: [
          { required: true, message: '用户ID不能为空', trigger: 'change' }
        ],
        app_id: [
          { required: true, message: '请选择应用', trigger: 'change' }
        ],
        add_time: [
          { required: true, message: '添加时间不能为空', trigger: 'change' }
        ],
        // photo: [
        //   { required: true, message: '截图不能为空', trigger: 'change' }
        // ],
        // photo_1: [
        //   { required: true, message: '截图不能为空', trigger: 'change' }
        // ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  methods: {
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      // console.log("ejwhe");
      // console.log(field);
      if(field == "photo_2"){
          this.form_data.photo_1= res.data.photo;
      }
      this.form_data.photo.push(res.data.photo);
      this[field + "_preview"] = res.data.photo;
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },

    //提交数据
    handleSubmit() {
      // console.log(this.form_data);
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$_invoke('adminUserAdditional_save', this.form_data).then(() => {
            this.$_msg.success('添加成功');
            this.$emit('on-success');
          }).finally(() => {
            this.submitting = false;
          })
        }
      }
      )

    },
  },
}
</script>